module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 97.68a3ff2c.png";